import React from "react";
import PropTypes from 'prop-types';

export default function IFrameBlock(
    {
        url,
        height,
        title
    }) {

    return (
        <div className="mt-5 mb-10">
            <iframe title={title} src={url} height={height} width='100%' />
        </div>
    )
}

IFrameBlock.propTypes = {
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    height: PropTypes.number
}